/**
 * Importance (High/Medium/Low) — SUBTLE tone classes, shared by every surface
 * that renders the H/M/L badge (Home My-priorities, Team Direction rows,
 * My-work linked rows). One source of truth so the levels read the same
 * everywhere.
 *
 * Design constraints (final-UX-polish pass):
 *  - distinguishable at a glance, but calm — importance is a personal planning
 *    signal, never an alarm;
 *  - NO red / destructive / danger styling (High is warm coral, the brand
 *    accent, not an emergency color);
 *  - readable contrast on both light and dark card surfaces (coral/coral-soft
 *    and muted are theme tokens that flip with the theme; the Medium beige
 *    uses an alpha tint over the card).
 *
 * The API field remains `priority` (1 = High, 2 = Medium, 3 = Low); "Importance"
 * is the UI label only.
 */
export function importanceToneClass(priority: number): string {
  if (priority === 1) return "bg-coral-soft/70 text-coral"; // High — warm coral tint
  if (priority === 3) return "bg-muted text-muted-foreground/80"; // Low — soft grey
  if (priority === 2) return "bg-amber-500/15 text-amber-800 dark:text-amber-300"; // Medium — neutral beige
  return "bg-muted text-muted-foreground"; // out-of-range → neutral
}
